import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemAdminIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.6 16.75L19.22 15.9L13.62 1.86001C13.1 0.400015 10.9 0.400015 10.37 1.86001L4.76999 15.9L2.38999 16.75C1.69999 17 1.23999 17.68 1.23999 18.46C1.23999 19.24 1.69999 19.92 2.38999 20.17L10.09 22.92C11.34 23.37 12.66 23.37 13.9 22.92L21.59 20.17C22.28 19.93 22.74 19.24 22.74 18.46C22.74 17.68 22.28 17 21.59 16.75H21.6ZM11.77 2.41001C11.88 2.14001 12.12 2.14001 12.23 2.41001L14.09 7.08001C13.59 7.22001 12.86 7.32001 12 7.32001C11.14 7.32001 10.41 7.21001 9.90999 7.08001L11.77 2.41001ZM9.44999 8.25001C10.13 8.46001 11.02 8.58001 12 8.58001C12.98 8.58001 13.88 8.46001 14.55 8.25001L16.46 13.03C15.78 13.39 14.23 13.77 12 13.77C9.76999 13.77 8.21999 13.39 7.53999 13.02L9.44999 8.24001V8.25001ZM7.07999 14.19C8.31999 14.79 10.35 15.02 12 15.02C13.65 15.02 15.68 14.79 16.92 14.19L18.19 17.37C17.69 17.81 15.45 18.47 12 18.47C8.54999 18.47 6.17999 17.77 5.78999 17.41L7.07999 14.18V14.19ZM21.1 18.75L13.4 21.5C12.48 21.83 11.51 21.83 10.6 21.5L2.89999 18.75C2.70999 18.7 2.70999 18.21 2.89999 18.16L4.29999 17.66C4.81999 19.89 11.24 19.97 12 19.97C12.76 19.97 19.18 19.9 19.7 17.66L21.1 18.16C21.29 18.2 21.3 18.7 21.1 18.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemAdminIcon.displayName = 'ItemAdminIcon';
